// ----------------------------------------------------------------------
export const createPalette = () => {
    return {
        primary: {
            contrastText: '#fffff',
            dark: '#1E235E',
            light: '#555B9F',
            main: '#2b3287',
        },
        background: {
            default: '#f1f1f1',
            paper: '#ffffff',
        },
    };
};
